import { ajax } from '../../../services/helper'
class ApiService {

    getEmployeeDeputeData = (from,to,city_id,kitchen_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeDeputedLocations/list?from="+from+"&to="+to+"&city_id="+city_id+"&kitchen_id="+kitchen_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getEmployeeDeputeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeDeputedLocations/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    validateEmployeeDepute = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeDeputedLocations/validateDeputy"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    addEmployeeDepute = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeDeputedLocations/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editEmployeeDepute = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeDeputedLocations/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Employee Depute/services/apiservices.js